import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SplitStringsPipe } from '@app/pipes/text-separator/text-separator.pipe';
import { SessionService } from '@app/services';


@Component({
  selector: 'mnf-pi-v2-opp-updates',
  standalone: true,
  imports: [CommonModule, SplitStringsPipe],
  templateUrl: './pi-v2-opp-updates.component.html',
  styleUrl: './pi-v2-opp-updates.component.scss'
})
export class PiV2OppUpdatesComponent {
  @Input() updates: string[];
  textDefault: string = '<p class="text-center mb-3 fs-18"><strong>Contenido exclusivo: Reportes periódicos</strong></p>' +
                        ' <p class="text-start mt-3 fs-15">Este contenido está reservado para los inversionistas del proyecto. Para acceder a los reportes detallados de pagos y rendimientos, por favor, <a class="text-decoration-underline cl-primary fw-bold" href="https://app.monific.com" target="_blank"> Inicia sesión </a> o <a class="text-decoration-underline cl-primary fw-bold" href="https://app.monific.com/registro" target="_blank"> Regístrate.</a> </p>';

  isSessionActive: boolean;
                  
  constructor(private sessionService: SessionService) { }

  ngOnInit(): void {
    this.isSessionActive = this.sessionService.isActiveJWTToken();
  }


}
